.root {
  width: 12.5rem;

  .label {
    font-size: 1rem;
    margin-bottom: 0.375rem;
    color: var(--mantine-color-primary-7);
    font-weight: 600;
  }

  .wrapper {
    height: 3rem;
  }

  .input {
    height: 100%;
    border: 1px solid var(--mantine-color-tertiary-2);

    &:active {
      border: 1px solid var(--mantine-color-tertiary-2);
    }

    &:focus-within {
      border: 1px solid var(--mantine-color-tertiary-9);
    }

    &::placeholder {
      font-size: 1rem;
      color: var(--mantine-color-tertiary-7);
    }

    &:disabled {
      background-color: var(--mantine-color-tertiary-0);

      &::placeholder {
        color: var(--mantine-color-tertiary-2);
      }
    }
  }

  .section {
    svg {
      stroke: var(--mantine-color-primary-7);
    }
  }

  .error {
    color: var(--mantine-color-red-7);
  }

  &[data-size='sm'] {
    .label {
      font-size: 0.875rem;
    }

    .wrapper {
      height: 2.625rem;
    }
  }

  &[data-error='true'] {
    .input {
      border: 1px solid var(--mantine-color-red-7);
      background: var(--mantine-color-primary-0);

      &::placeholder {
        color: var(--mantine-color-red-7);
      }
    }
  }

  &[data-variant='filled'] {
    &[data-error='true'] {
      .input {
        border: 1px solid var(--mantine-color-red-7);
        background: var(--mantine-color-primary-0);

        &::placeholder {
          color: var(--mantine-color-red-7);
        }
      }
    }

    .input {
      border: none;
      background: var(--mantine-color-primary-0);

      &::placeholder {
        font-size: 0.875rem;
        color: var(--mantine-color-tertiary-7);
      }

      &:active {
        border: 1px solid var(--mantine-color-tertiary-2);
      }

      &:focus-within {
        border: 1px solid var(--mantine-color-tertiary-9);
      }

      &:disabled {
        background-color: var(--mantine-color-tertiary-0);
      }
    }
  }

  &[data-variant='unstyled'] {
    &[data-error='true'] {
      .input {
        border: none;
        background: transparent;

        &::placeholder {
          color: var(--mantine-color-red-7);
        }
      }
    }

    .input {
      border: none;
      background: transparent;

      &:focus-within {
        border: none;
      }

      &::placeholder {
        font-size: 1rem;
        color: var(--mantine-color-tertiary-7);
      }

      &:disabled {
        background-color: var(--mantine-color-tertiary-0);
      }
    }
  }
}
